import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { ConfirmDialogComponent } from './dialogs-components/confirm-dialog/confirm-dialog.component';
import { DialogService } from 'app/dialogs/dialog.service';
import { DialogDescriptionComponent } from './dialogs-components/dialog-description/dialog-description.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AlertDialogComponent } from './dialogs-components/alert-dialog/alert-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
    imports: [
        SharedModule,
        FlexLayoutModule,
        TranslateModule.forChild(),
        MatDialogModule,
    ],
    declarations: [
        ConfirmDialogComponent,
        DialogDescriptionComponent,
        AlertDialogComponent,
    ],
    providers: [
        DialogService
    ]
})
export class DialogModule {
}
